import UseStyle from '../../config/styles';
export default UseStyle;
